require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/login.template.htm');
require('dhtmlxMessage');
var i18n = require("l10n");


var TheView = Backbone.View.extend({
    el: $("#body"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	initialize: function () {
        this.render();
	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		this.superRender();

		this.$el.html(this.template());
	},
	events:{
		"click #loginButton": "login",
		"submit #form": "login",
		//"keyup #password": "loginWithEnter"
	},
	login: function()
	{
		var self = this;
		this.showActionProgressBar();

        var username = encodeURIComponent($("#username").val());
        var password = encodeURIComponent($("#password").val());

        $.ajaxDefaultQ({
            url: '/rest/auth/login',
            type: 'POST',
            data: "username=" + username + "&password=" + password,
        }).done(function(response, status, xhr){
            if(status == "success")
            {
                self.hideActionProgressBar();
                window.open('./','_self');
            }else {
                console.log("resp: ",response);
                console.log("status: ",status);
            }

        })
        .fail(function(error) {
            var errorMsg = "";
            var statusCode = error.status;
            var systemErrorCode = error.responseJSON && error.responseJSON.error.exception.code ? error.responseJSON.error.exception.code : -1;

            if(statusCode == 406 && systemErrorCode == "2-2-5")
                errorMsg = i18n.t("user.already_logged_in");
            else if(statusCode == 502)
                 errorMsg = i18n.t("server.is_down");
            else
                errorMsg = i18n.t("account.check_credentials");

            dhtmlx.alert({
                type: "alert",
                text: errorMsg,
                callback: function (result) {
                    $("#password").val('');
                }
            });

            document.cookie = "status=0";

            self.hideActionProgressBar();

        })

		return false;
	},
	loginWithEnter: function(event)
	{

	 	event.preventDefault();
        if (event.keyCode == 13) {
        	if($("#username").val() != "" && $("#password").val() != null)
           	 	this.login();
        }
	},
	showActionProgressBar: function()
    {
        window.progressBarCounter = (window.progressBarCounter == null ? 0 : window.progressBarCounter) + 1;

        $("#login-container-progress").css("display", "block");
        $("body").addClass("noScroll");
    },
    hideActionProgressBar: function()
    {
        window.progressBarCounter = (window.progressBarCounter == null ? 0 : window.progressBarCounter) - 1;
        if(window.progressBarCounter < 0)
            window.progressBarCounter = 0;

        if(window.progressBarCounter == 0)
        {
            $("#login-container-progress").css("display", "none");
            $("body").removeClass("noScroll");
        }
    },

});


module.exports= TheView;